import React from 'react';
import { createRoot } from 'react-dom/client';  // ← Change this import
import { BrowserRouter } from 'react-router-dom';
import './common/css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';  // ← modern import style (optional but cleaner)
import config from './aws-exports';

Amplify.configure(config);

console.log('React version: ', React.version);



const rootElement = document.getElementById('root');
const root = createRoot(rootElement);  // ← Create the root once

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance....
reportWebVitals();